var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2007 13.1895C12.2132 13.1895 5.57504 19.0008 4.2374 26.6492C3.978 28.1323 5.10776 29.4932 6.6049 29.4932H33.7963C35.2935 29.4932 36.4232 28.1323 36.1638 26.6492C34.8263 19.0007 28.1881 13.1895 20.2007 13.1895Z",
    fill: "#DB7094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2374 26.6495C3.978 28.1327 5.10776 29.4935 6.6049 29.4935H33.7963C35.2935 29.4935 36.4232 28.1327 36.1638 26.6495C35.7578 24.3281 34.8628 22.1764 33.5907 20.3047H6.81046C5.53839 22.1764 4.64337 24.3281 4.2374 26.6495Z",
    fill: "#DC7296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2007 4C12.2132 4 5.57504 9.81131 4.2374 17.4597C3.978 18.9428 5.10776 20.3038 6.6049 20.3038H33.7963C35.2935 20.3038 36.4232 18.9429 36.1638 17.4597C34.8263 9.81125 28.1881 4 20.2007 4Z",
    fill: "#DC7296",
    fillOpacity: 0.27
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 35.9991C23.7736 35.9991 26.6705 33.0852 26.6705 29.4908C26.6705 25.8963 23.7736 22.9824 20.2 22.9824C16.6264 22.9824 13.7295 25.8963 13.7295 29.4908C13.7295 33.0852 16.6264 35.9991 20.2 35.9991Z",
    fill: "#FEEFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.1509 13.2402C14.5877 13.2402 9.67985 16.0598 6.76074 20.3552H33.5411C30.622 16.0598 25.7141 13.2402 20.1509 13.2402Z",
    fill: "#DE7699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeFour);
export default __webpack_public_path__ + "static/media/shape-four.d3d9e8a3978980f1d16f9b4073e9a5bd.svg";
export { ForwardRef as ReactComponent };